import Vue from "vue";
import UrlResolver from "../UrlResolver";
import QueryString from "../parser/QueryString";

export default {
    visit(columns, embeddedModules) {
        let isSrpColumn = false;
        let detailsColumns = [];
        let linkColumns = [];
        let offerColumns = [];
        let percentColumns = [];
        let simplyOffers = [];
        let booleanColumns = [];
        let componentsColumns = [];

        columns.forEach((c, i) => {
            if (c.data === 'srp_price') {
                isSrpColumn = true;
            }

            if (c.components && c.components.length > 0) {
                componentsColumns.push(i);
            }

            if (!c.formatter) {
                return;
            }

            switch (c.formatter.type) {
                case 'details':
                    if (embeddedModules.length > 0) {
                        detailsColumns.push(i);
                    }
                    break;
                case 'link':
                    linkColumns.push(i);
                    break;
                case 'offer':
                    offerColumns.push(i);
                    break;
                case 'percent':
                    percentColumns.push(i);
                    break;
                case 'simply_offer':
                    simplyOffers.push(i);
                    break;
                case 'boolean':
                    booleanColumns.push(i);
                    break;
            }
        });

        return [{
            render: (value, index, row) => {
                return value + '<a href="/product-history/' + row['product_id'] + '" target="_blank">' +
                    '<span class="pull-right icon icon-detail icon-new-tab" title="' + Vue.prototype.$translate.text('Details in new window') + '"></span>' +
                    '</a>';
            },
            targets: detailsColumns
        }, {
            render: (value, index, row, settings) => {
                let columnFormatter = columns[settings.col].formatter;
                let linkIndex = 'offer_link';

                if (columnFormatter && columnFormatter.index) {
                    linkIndex = columnFormatter.index;
                }

                if (row[linkIndex]) {
                    return '<a href="' + row[linkIndex] + '" target="_blank" rel="noreferrer">' + value + '</a>';
                }

                return value;
            },
            targets: linkColumns
        }, {
            render: (value, index, row, settings) => {
                if (null === value) {
                    return value;
                }

                let columnIndex = columns[settings.col].data;
                let offerPrice = row[columnIndex + '_price'];
                let offerInstallmentPrice = row[columnIndex + '_offer_installment_price'];
                let installment_value = row[columnIndex + '_installment_value'];
                let quantity_installment = row[columnIndex + '_quantity_installment'];
                let offerStrikeThroughPrice = row[columnIndex + '_strikethrough_price'];
                let pricePercentDiff = row[columnIndex + '_price_percent_diff'];
                let color = '#' + row[columnIndex + '_color'];
                let pivot = row[columnIndex + '_pivot'];
                let sellerName = row[columnIndex + '_offer_seller_name'];
                let promotions = row[columnIndex + '_promotions'];
                let bestseller = row[columnIndex + '_bestseller'];
                let newOffer = row[columnIndex + '_new_offer'];
                let parentLink = row[columnIndex + '_offer_parent_link'];
                let promotionTooltip = this.renderPromotionTooltip(promotions ? promotions : []);
                let promotionCodeTooltip = this.renderPromotionCodeTooltip(promotions ? promotions : []);
                let priceGap = row[columnIndex + '_gap'];
                let res = '<span style="white-space: nowrap;">' + row[columnIndex + '_offer_shop_name'];

                if (parentLink) {
                    res = '<a target="_blank" href="' + parentLink + '" rel="noreferrer">' + res + '</a>';
                }

                if (bestseller) {
                    res += '<span class="icon icon-detail icon-bestseller" title="' + Vue.prototype.$translate.text('Bestseller') + '"></span>';
                }

                if (newOffer) {
                    res += '<span class="icon icon-detail icon-new-offer" title="' + Vue.prototype.$translate.text('New offer') + '"></span>';
                }

                if (promotionTooltip) {
                    res += '<span class="icon icon-detail icon-promotions"></span>';
                }

                if (promotionCodeTooltip) {
                    res += '<span class="icon icon-detail icon-promotion-code" title="' + promotionCodeTooltip + '"></span>';
                }

                if (sellerName) {
                    res = '<span class="seller-name"> (' + sellerName + ') </span>' + res;
                }

                res += '<br />' +
                    '<span>' +
                    (offerInstallmentPrice ? ('<span class="offer-installment-price"><span class="icon icon-detail icon-affordability"></span>&nbsp;' + offerInstallmentPrice + '</span>&nbsp;&nbsp;&nbsp;') : '') +
                    '<a target="_blank" href="' + row[columnIndex + '_offer_link'] + '" rel="noreferrer">' + offerPrice + '</a>' +
                    '' + (offerStrikeThroughPrice ? ('&nbsp;&nbsp;&nbsp;<span class="strikethrough-price">' + offerStrikeThroughPrice + '</span>') : '') +
                    '</span><br>';

                if(offerInstallmentPrice) {
                    res += '<span class="installment-price">' + quantity_installment + ' x ' + installment_value + '</span><br>';
                }

                if (isSrpColumn && null !== pricePercentDiff && typeof pricePercentDiff !== 'undefined') {
                    res += '<span style="color: ' + color + '"><small>(' + pricePercentDiff + '%)</small></span>';
                }

                if (pivot) {
                    res = '<span class="pivot-offer">' + res + '</span>';
                }

                if (priceGap) {
                    res = '<div class="gap-placeholder">' + res + '</div>';
                }

                if (promotionTooltip) {
                    return '<div v-popover:tooltip="' + promotionTooltip + '">' + res + '</div>';
                }

                return res;
            },
            targets: offerColumns
        }, {
            render: (value, index, row, settings) => {
                let res = '<span class="glyphicon glyphicon-hand-right"></span>';

                if (null === value) {
                    return value;
                }

                if (parseFloat(value) > 0) {
                    res = '<span class="glyphicon glyphicon-thumbs-up progress-up"></span>';
                } else if (parseFloat(value) < 0) {
                    res = '<span class="glyphicon glyphicon-thumbs-down progress-down"></span>';
                }

                return '<span class="display-in-one-line">' + value + '% ' + res + '</span>';
            },
            targets: percentColumns
        }, {
            render: (value, index, row, settings) => {
                let res = '';
                let columnIndex = columns[settings.col].data;

                if (value) {
                    let offerPrice = row[columnIndex + '_price'];
                    res = '<a target="_blank" href="' + row[columnIndex + '_offer_link'] + '" rel="noreferrer">' + offerPrice + '</a>';

                    if (row['srp_price']) {
                        let pricePercentDiff = row[columnIndex + '_percent_diff'];
                        let color = '#' + row[columnIndex + '_color'];
                        res += '<span style="color: ' + color + '">';

                        if (null !== pricePercentDiff) {
                            res += '<br /><small>(' + pricePercentDiff + '%)</small>';
                        }

                        res += '</span>';
                    }
                }

                return res;
            },
            targets: simplyOffers
        }, {
            render: function (value, type, row, settings) {
                if (true === value) {
                    return Vue.prototype.$translate.text('Yes');
                }
                if (false === value) {
                    return Vue.prototype.$translate.text('No');
                }

                return '';
            },
            targets: booleanColumns
        }, {
            render: (value, index, row, settings) => {
                return `<div id="components_${settings.col}_${settings.row}"></div>`;
            },
            targets: componentsColumns
        }];
    },
    renderPromotionTooltip(promotions) {
        let breakLine = '&#010;';
        let txt = '';

        promotions.forEach(function (value, index) {
            if (value['name']) {
                txt += breakLine + breakLine + value['name'];
            }
        });

        return txt ? Vue.prototype.$translate.text('Promotions') + ':' + txt : '';
    },
    renderPromotionCodeTooltip(promotions) {
        let breakLine = '&#010;';
        let txt = '';

        promotions.forEach(function (value, index) {
            if (value['code']) {
                txt += breakLine + breakLine + value['code'];
            }
        });

        return txt;
    }
}


// WEBPACK FOOTER //
// ./src/services/product/columnVisitor.js